// src/components/CardImg.jsx
import React from 'react';
import { motion } from 'framer-motion';
import '../styles/colors.css'

const CardImg = ({ title, description, img, link }) => {
  
  const handleClick = (e) => {
    e.preventDefault();
    const targetElement = document.querySelector(link);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div onClick={handleClick} className="cursor-pointer block ">

      <motion.div
        className="card-img"
        whileHover={{ scale: 1.05 }}
      >
        <img src={img} alt={title} className="w-full h-56 object-cover" />
        <div className="p-6 ">
          <h4 className="text-2xl mb-2">{title}</h4>
          <p className='mb-2'>{description}</p>
        </div>
      </motion.div>

    </div>

  );
};

export default CardImg;